import React, { useEffect, useState, useRef } from 'react';
import axios from 'axios';
import PropTypes from 'prop-types';
import { Constants } from '../lib/const/constants';
import { useNavigate } from 'react-router-dom';
// import { getCurrencySymbol } from '../lib/currenyUtils';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import CurrencyConverterSkeleton from '../components/ui/CurrencyConverterSkeleton';
import { encryptPayload } from '../utils/encryption';

function CurrencyConverterFormScreen({
  convertAgainData,
  onConvertAgainApplied,
}) {
  const navigate = useNavigate();
  // const location = useLocation();
  const [dropdownOpen, setDropdownOpen] = useState(false);
  const [selectedCurrency, setSelectedCurrency] = useState(null);
  const [receiveDropdownOpen, setReceiveDropdownOpen] = useState(false);
  const [selectedReceiveCurrency, setSelectedReceiveCurrency] = useState(null);

  const [receiveCurrency, setReceiveCurrency] = useState('');
  const [receiveCurrencyValue, setReceiveCurrencyValue] = useState('');
  const [, setReceiveCurrencyFlag] = useState('');

  const [, setCountries] = useState([]);
  const [, setLoading] = useState(false);
  const [balLoading, setBalLoading] = useState(false);
  const [amount, setAmount] = useState();
  const [type, settype] = useState('sell');
  const ref = useRef(null);

  const [convertloading, setConvertLoading] = useState(false);
  const [buyAmount, setBuyAmount] = useState();
  const [exchangeRate, setexchangeRate] = useState(0);
  const [convertDate, setConvertDate] = useState('');
  const [contactId, setContactId] = useState('');
  const [recentEdit, setrecentEdit] = useState();
  const [currency, setCurrency] = useState();
  const [currencyid, setCurrencyId] = useState();
  const [, setBalance] = useState();
  // const [, setreceivebalance] = useState();
  const [usedBalances, setusedBalances] = useState([]);
  // const [clearBankBalance, setclearBankBalance] = useState(0.0);
  // const [currencyCloudBalance, setcurrencyCloudBalance] = useState(0.0);
  const [balances, setBalances] = useState([]);
  const [, setRecentLoaded] = useState();
  // const [clearBankConfiguration, setclearBankConfiguration] = useState();
  const [, setreceivingCurrency] = useState();
  const [, setreference] = useState();
  // const [, setShowproceed] = useState(true);
  const [buyCurrency, setBuyCurrency] = useState();
  const [sellCurrency, setSellCurrency] = useState();
  const [convertTime, setConvertTime] = useState('');

  const timeout = useRef(null);
  const amountRef = useRef();

  // console.log(amount);
  // console.log(usedBalances);
  // console.log(buyAmount);
  // console.log(contactId);
  // console.log('location', location);
  // console.log('pathname', location.pathname);
  // console.log('Buy Currency', buyCurrency);
  // console.log('Sell Currency', sellCurrency);

  useEffect(() => {
    if (!currencyid || !receiveCurrency) return;

    const isDefault = !amountRef.current;

    if (isDefault) {
      // ✅ FORCE correct behavior for default case
      setrecentEdit('sell');
      amountRef.current = 1;
      setAmount(1);

      getConversionData(1, receiveCurrency);
    } else {
      // ✅ Keep existing behavior
      getConversionData(amountRef.current, receiveCurrency);
    }
  }, [currencyid, receiveCurrency]);

  useEffect(() => {
    if (!convertAgainData || balances.length === 0) return;

    setAmount(convertAgainData.sellAmount);
    amountRef.current = convertAgainData.sellAmount;
    setBuyAmount(convertAgainData.buyAmount);
    setCurrency(convertAgainData.sellCurrency);
    setCurrencyId(convertAgainData.sellCurrencyId);
    setReceiveCurrencyValue(convertAgainData.buyCurrency);
    setReceiveCurrency(convertAgainData.buyCurrencyId);

    // ✅ Find directly from balances — guaranteed to have proper meta.flag
    const sellObj = balances.find(
      (b) => b.currency === convertAgainData.sellCurrency,
    );
    const buyObj = balances.find(
      (b) => b.currency === convertAgainData.buyCurrency,
    );

    setSelectedCurrency({
      currency: convertAgainData.sellCurrency,
      currencyid: convertAgainData.sellCurrencyId,
      flag: sellObj ? getFlagUrl(sellObj) : '',
    });

    setSelectedReceiveCurrency({
      currency: convertAgainData.buyCurrency,
      currencyid: convertAgainData.buyCurrencyId,
      flag: buyObj ? getFlagUrl(buyObj) : '',
    });

    setrecentEdit('sell');
    if (onConvertAgainApplied) {
      onConvertAgainApplied();
    }
  }, [convertAgainData?.trigger, balances]);

  useEffect(() => {
    if (ref.current) return;
    ref.current = true;
    getBalances();
    getData();
    removeData();
  }, []);

  const getData = async () => {
    setLoading(true);
    settype('sell');
    const token = sessionStorage.getItem('login_token');
    const defaultBank = sessionStorage.getItem('defaultBank');
    const parsedWorkspace = JSON.parse(
      sessionStorage.getItem('login_workspaces'),
    );
    var ref = '';
    if (defaultBank === 'Clear Bank as Service') {
      console.log('cb');
    } else {
      if (Object.keys(parsedWorkspace[0].accounts).length > 0) {
        console.log('cc');
      } else {
        ref = JSON.parse(sessionStorage.getItem('login_workspaces'))[0]
          .memberships.urn;
        setreference(ref);
      }
    }
    if (ref == '') {
      await axios
        .get(Constants.BASE_URL + 'API-FX-162-CONVERTCOUNTRIES', {
          headers: {
            Authorization: 'Bearer ' + JSON.parse(token),
            fx_key: Constants.SUBSCRIPTION_KEY,
          },
        })
        .then((resp) => {
          setCountries(resp.data.buying_currencies);
          setLoading(false);
        })
        .catch(() => {
          setLoading(false);
        });
    } else {
      // console.log('countries');
      setCountries(Constants.INDIVIDUAL_CURRENCIES);
      setLoading(false);
    }
  };

  const getBalances = async () => {
    setBalLoading(true);
    const login_workspaces_id = sessionStorage.getItem('login_workspaces_id');
    const login_token = sessionStorage.getItem('login_token');
    try {
      const resp = await axios.get(
        Constants.BASE_URL +
          'API-FX-231-GET-WALLET-BALANCES/' +
          login_workspaces_id,
        {
          headers: {
            Authorization: 'Bearer ' + JSON.parse(login_token),
            fx_key: Constants.SUBSCRIPTION_KEY,
          },
        },
      );
      const balArray = Object.values(resp.data);
      setusedBalances(resp.data.used_balances);
      balArray.pop();
      // setcurrencyCloudBalance(resp.data.currency_cloud_account_balance);
      // setclearBankBalance(resp.data.clear_bank_account_balance);
      // setclearBankConfiguration(resp.data.fees_configuration);
      balArray.pop();
      balArray.pop();
      balArray.pop();
      // console.log('clearbank' + clearBankBalance);
      // console.log('currency' + currencyCloudBalance);
      // console.log('clearBankConfiguration' + clearBankConfiguration);
      if (balArray.length > 0) {
        setBalances(balArray);
        // console.log('balArray');
        if (balArray.length == 1) {
          balArray.push({
            id: 3,
            currency: 'INR',
            balance: 0,
            meta: {
              code: 'IN',
              name: 'India',
              country_id: 105,
              flag: 'https://uat.dhigna.com/flags/IN.PNG',
            },
            created_at: '2025-06-28T08:23:31.170932Z',
            updated_at: '2025-06-28T08:23:31.170935Z',
          });
        }
      } else {
        const defaultBank = sessionStorage.getItem('defaultBank');
        const parsedWorkspace = JSON.parse(
          sessionStorage.getItem('login_workspaces'),
        );
        var ref = '';
        if (defaultBank === 'Clear Bank as Service') {
          console.log('cb');
        } else {
          if (Object.keys(parsedWorkspace[0].accounts).length > 0) {
            console.log('cc');
          } else {
            ref = JSON.parse(sessionStorage.getItem('login_workspaces'))[0]
              .memberships.urn;
            setreference(ref);
          }
        }
        if (ref != '') {
          setBalances(Constants.INDIVIDUAL_BALANCES_CURRENCIES);
        }
      }
      setBalLoading(false);
    } catch (err) {
      console.log(err.response.data);
      setBalLoading(false);
    } finally {
      setBalLoading(false);
    }
  };

  const getConversionData = async (
    amt,
    currencyReceive,
    sellCurrencyIdOverride,
  ) => {
    setConvertLoading(true);

    try {
      const token = sessionStorage.getItem('login_token');
      const staff_login_id = sessionStorage.getItem('staff_login_id');
      const workspaceId = sessionStorage.getItem('login_workspaces_id');

      const activeSellCurrencyId = sellCurrencyIdOverride ?? currencyid;

      // ✅ Guard conditions
      if (!currencyReceive || !activeSellCurrencyId) {
        return;
      }

      if (activeSellCurrencyId === currencyReceive) {
        toast.error('Same currency cannot be converted.');
        return;
      }

      if (activeSellCurrencyId === 105) {
        toast.error('Currency not supported.');
        return;
      }

      setexchangeRate(0);

      // ✅ Default to 1 for rate calculation
      const convertamount = amt && amt > 0 ? amt : 1;

      setreceivingCurrency(currencyReceive);
      const encryptedPayload = await encryptPayload({
          sell_currency_country_id: activeSellCurrencyId,
          buy_currency_country_id: currencyReceive,
          amount: parseFloat(convertamount).toFixed(2),
          workspace_id: workspaceId,
          type: type,
          staff_login_id: staff_login_id,
          platform: 'web',
          extraParamValidation: 'trustedfromweb'
        });
      const response = await axios.post(
        Constants.BASE_URL + 'API-FX-163-CONVERTRATES',
        encryptedPayload,
        {
          headers: {
            fx_key: Constants.SUBSCRIPTION_KEY,
            Authorization: 'Bearer ' + JSON.parse(token),
          },
        },
      );

      if (
        response?.data &&
        response.data.code !== 400 &&
        response.data.success !== false
      ) {
        const meta = response.data.data.meta;

        setRecentLoaded('normal');

        // ✅ Always update exchange rate
        setexchangeRate(parseFloat(meta.client_rate));

        // ✅ Only update input values if user entered amount
        // if (amt && amt > 0) {
        //   setAmount(parseFloat(meta.client_sell_amount).toFixed(2));
        //   setBuyAmount(parseFloat(meta.client_buy_amount).toFixed(2));
        // } else {
        //   // Only update buy amount for rate preview
        //   setBuyAmount(parseFloat(meta.client_buy_amount).toFixed(2));
        // }
        // ✅ Detect if this is default mode (no user input yet)
        const isDefault = !amountRef.current;

        if (isDefault) {
          // 🔥 Force SELL = 1 always
          setAmount(1);
          amountRef.current = 1;

          setBuyAmount(parseFloat(meta.client_buy_amount).toFixed(2));
        } else {
          // ✅ Keep existing behavior (user entered amount)
          setAmount(parseFloat(meta.client_sell_amount).toFixed(2));
          setBuyAmount(parseFloat(meta.client_buy_amount).toFixed(2));
        }

        // ✅ Date formatting
        const updatedate = new Date(response.data.data.updated_at);
        setConvertDate(
          `${updatedate.getDate()}-${updatedate.getMonth() + 1}-${updatedate.getFullYear()}`,
        );
        const ukTime = updatedate.toLocaleString('en-GB', {
          timeZone: 'Europe/London',
          hour: '2-digit',
          minute: '2-digit',
          second: '2-digit',
          hour12: false,
        });

        setConvertTime(ukTime);

        setContactId(response.data.contact_id);
        setBuyCurrency(meta.client_buy_currency);
        setSellCurrency(meta.client_sell_currency);

        // ✅ Persist currencies
        sessionStorage.setItem(
          'last_sell_currency',
          JSON.stringify({
            currency: meta.client_sell_currency,
            currencyid: activeSellCurrencyId,
            flag: selectedCurrency?.flag,
          }),
        );

        sessionStorage.setItem(
          'last_buy_currency',
          JSON.stringify({
            currency: meta.client_buy_currency,
            currencyid: currencyReceive,
            flag: selectedReceiveCurrency?.flag,
          }),
        );
      } else {
        toast.error(response?.data?.message || 'Rate could not be retrieved.');
      }
    } catch (error) {
      console.error('Error during getConversionData:', error);
      toast.error(
        error?.response?.data?.message || 'Error retrieving conversion rate.',
      );
    } finally {
      // ✅ Always stop loader
      setConvertLoading(false);
      if (onConvertAgainApplied) {
        onConvertAgainApplied();
      }
    }
  };

  const removeData = async () => {
    sessionStorage.removeItem('sell');
    sessionStorage.removeItem('buy');
  };

  const onChangeHandler = (value) => {
    clearTimeout(timeout.current);
    if (!value) {
      setAmount('');
      setBuyAmount('');
      return;
    }
    timeout.current = setTimeout(() => {
      getConversionData(value, receiveCurrency);
    }, 2000);
  };

  const onInverseChangeHandler = (value) => {
    clearTimeout(timeout.current);
    if (!value) {
      setAmount('');
      setBuyAmount('');
      return;
    }
    timeout.current = setTimeout(() => {
      getInverseConversionData(value, receiveCurrency);
    }, 2000);
  };

  const getInverseConversionData = async (
    amt,
    currencyReceive,
    sellCurrencyIdOverride,
  ) => {
    const token = sessionStorage.getItem('login_token');
    const staff_login_id = sessionStorage.getItem('staff_login_id');
    const activeSellCurrencyId = sellCurrencyIdOverride ?? currencyid;
    if (
      currencyReceive != '' &&
      currencyReceive != null &&
      amt != '' &&
      amt != 0
    ) {
      setConvertLoading(true);
      // console.log(amt);
      var convertamount = parseFloat(buyAmount).toFixed(2);
      if (amt == '' || amt == null) {
        convertamount = buyAmount;
        setBuyAmount(buyAmount);
      } else {
        convertamount = amt;
        setBuyAmount(amt);
      }
      const workspaceId = sessionStorage.getItem('login_workspaces_id');
      if (convertamount != '' && convertamount != null) {
        if (activeSellCurrencyId == currencyReceive) {
          toast.error('Same currency cannot be converted.');
        } else if (activeSellCurrencyId == 105) {
          toast.error('Currency not supported.');
          setConvertLoading(false);
          return;
        } else {
          setRecentLoaded('inverse');
          setreceivingCurrency(currencyReceive);
          if (
            activeSellCurrencyId != '' &&
            activeSellCurrencyId != null &&
            currencyReceive != '' &&
            currencyReceive != null
          ) {
            const encryptedPayload = await encryptPayload({
          sell_currency_country_id: activeSellCurrencyId,
                  buy_currency_country_id: currencyReceive,
                  amount: parseFloat(convertamount).toFixed(2),
                  workspace_id: workspaceId,
                  type: 'buy',
                  staff_login_id: staff_login_id,
          platform: 'web',
          extraParamValidation: 'trustedfromweb'
        });
        
            await axios
              .post(
                Constants.BASE_URL + 'API-FX-163-CONVERTRATES',
                encryptedPayload,
                {
                  headers: {
                    fx_key: Constants.SUBSCRIPTION_KEY,
                    Authorization: 'Bearer ' + JSON.parse(token),
                  },
                },
              )
              .then((resp) => {
                if (resp.data.code != 400) {
                  setBuyAmount(
                    parseFloat(resp.data.data.meta.client_buy_amount).toFixed(
                      2,
                    ),
                  );
                  setAmount(
                    parseFloat(resp.data.data.meta.client_sell_amount).toFixed(
                      2,
                    ),
                  );
                  setexchangeRate(parseFloat(resp.data.data.meta.client_rate));
                  setBuyCurrency(resp.data.data.meta.client_buy_currency);
                  setSellCurrency(resp.data.data.meta.client_sell_currency);
                  const updatedate = new Date(resp.data.data.updated_at);
                  setConvertDate(
                    updatedate.getDate() +
                      '-' +
                      (+updatedate.getMonth() + 1) +
                      '-' +
                      updatedate.getFullYear(),
                  );
                  const ukTime = updatedate.toLocaleString('en-GB', {
                    timeZone: 'Europe/London',
                    hour: '2-digit',
                    minute: '2-digit',
                    second: '2-digit',
                    hour12: false,
                  });

                  setConvertTime(ukTime);
                  setContactId(resp.data.contact_id);
                } else {
                  toast.success(resp.data.message);
                  navigate('/', { state: { qr_login_completed: 1 } });
                }
                setConvertLoading(false);
                if (onConvertAgainApplied) {
                  onConvertAgainApplied();
                }
              })
              .catch((error) => {
                toast.error(error.response.data.message);
                setConvertLoading(false);
              });
          }
        }
      }
    }
    setConvertLoading(false);
  };

  const getAvailableBalance = (currencyCode) => {
    const balanceObj = balances.find((b) => b.currency === currencyCode);
    if (!balanceObj) return 0;
    const used = usedBalances[currencyCode] || 0;
    const available = parseFloat(balanceObj.balance) - parseFloat(used);
    return available < 0 ? 0 : available;
  };

  const getFlagUrl = (resp) => {
    switch (resp.currency) {
      case 'EUR':
        return `${Constants.FXMASTER_BASE_URL}flags/eu.png`;
      case 'RON':
        return `${Constants.FXMASTER_BASE_URL}flags/ro.png`;
      case 'DKK':
        return `${Constants.FXMASTER_BASE_URL}flags/dk.png`;
      case 'NOK':
        return `${Constants.FXMASTER_BASE_URL}flags/no.png`;
      case 'SEK':
        return `${Constants.FXMASTER_BASE_URL}flags/se.png`;
      case 'MYR':
        return `${Constants.FXMASTER_BASE_URL}flags/my.png`;
      default:
        return `${Constants.FXMASTER_BASE_URL}flags/${resp?.meta?.flag?.split('/').pop()}`;
    }
  };

  // const dropdownScrollStyle = {
  //   maxHeight: '200px',
  //   overflowY: 'scroll',
  //   scrollbarWidth: 'thin',
  //   msOverflowStyle: 'auto',
  //   WebkitOverflowScrolling: 'touch',
  // };

  // const spinnerStyle = {
  //   width: 16,
  //   height: 16,
  //   border: '2px solid rgba(255,255,255,0.4)',
  //   borderTop: '2px solid #fff',
  //   borderRadius: '50%',
  //   animation: 'spin 0.7s linear infinite',
  //   display: 'inline-block',
  //   flexShrink: 0,
  // };

  useEffect(() => {
    if (balances.length === 0) return;

    const lastSell = sessionStorage.getItem('last_sell_currency');
    const lastBuy = sessionStorage.getItem('last_buy_currency');

    // ✅ helper to safely parse
    const safeParse = (value) => {
      try {
        return JSON.parse(value);
      } catch {
        return value; // return raw string like "EUR"
      }
    };

    // ✅ RESTORE SELL (NO VALIDATION)
    if (lastSell) {
      const parsedSell = safeParse(lastSell);

      const currencyCode =
        typeof parsedSell === 'string' ? parsedSell : parsedSell.currency;

      const sellObj = balances.find((b) => b.currency === currencyCode) || {};

      setSelectedCurrency({
        currency: currencyCode,
        currencyid: sellObj?.meta?.country_id || parsedSell.currencyid,
        flag: sellObj ? getFlagUrl(sellObj) : parsedSell.flag,
      });

      setCurrency(currencyCode);
      setCurrencyId(sellObj?.meta?.country_id || parsedSell.currencyid);
    }

    // ✅ RESTORE BUY (NO VALIDATION)
    if (lastBuy) {
      const parsedBuy = safeParse(lastBuy);

      const currencyCode =
        typeof parsedBuy === 'string' ? parsedBuy : parsedBuy.currency;

      const buyObj = balances.find((b) => b.currency === currencyCode) || {};

      setSelectedReceiveCurrency({
        currency: currencyCode,
        currencyid: buyObj?.meta?.country_id || parsedBuy.currencyid,
        flag: buyObj ? getFlagUrl(buyObj) : parsedBuy.flag,
      });

      setReceiveCurrency(buyObj?.meta?.country_id || parsedBuy.currencyid);
      setReceiveCurrencyValue(currencyCode);
    }

    // ✅ fallback ONLY if nothing in session
    if (!lastSell && balances.length > 0) {
      const defaultSell = balances[0];
      setSelectedCurrency({
        currency: defaultSell.currency,
        currencyid: defaultSell.meta.country_id,
        flag: getFlagUrl(defaultSell),
      });
      setCurrency(defaultSell.currency);
      setCurrencyId(defaultSell.meta.country_id);
    }

    if (!lastBuy && balances.length > 1) {
      const defaultBuy = balances[1];
      setSelectedReceiveCurrency({
        currency: defaultBuy.currency,
        currencyid: defaultBuy.meta.country_id,
        flag: getFlagUrl(defaultBuy),
      });
      setReceiveCurrency(defaultBuy.meta.country_id);
      setReceiveCurrencyValue(defaultBuy.currency);
    }
  }, [balances]);

  const availableBalance = currency ? getAvailableBalance(currency) : 0;

  return (
    <div className="flex justify-center py-3">
      <ToastContainer />

      {balLoading ? (
        <CurrencyConverterSkeleton />
      ) : (
        <div className="w-[672px]">
          {/* TITLE */}
          <h2 className="text-center font-bold text-xl mb-4">
            Convert Currency
          </h2>

          {/* CARD */}
          <div className="border border-[#E6E5E5] rounded-2xl p-6 bg-white shadow-[0px_4px_16px_-4px_rgba(0,0,0,0.06)]">
            {/* SELL */}
            <div>
              <p className="text-sm font-semibold mb-2">Sell Currency</p>

              <div className="flex items-center border border-[#E6E5E5] rounded-xl p-3">
                {/* DROPDOWN */}
                <div className="relative flex items-center gap-1.5">
                  {selectedCurrency?.flag && (
                    <img
                      src={selectedCurrency.flag}
                      className="w-[30px] h-[28px] rounded-sm"
                    />
                  )}

                  <div
                    className="flex items-center gap-1 cursor-pointer select-none"
                    onClick={(e) => {
                      e.stopPropagation();
                      setDropdownOpen(!dropdownOpen);
                      setReceiveDropdownOpen(false);
                    }}
                  >
                    <span className="text-sm font-medium">
                      {selectedCurrency?.currency || currency || 'Select'}
                    </span>
                    <svg
                      className="w-3 h-3 text-gray-500"
                      viewBox="0 0 12 12"
                      fill="currentColor"
                    >
                      <path d="M6 8L1 3h10L6 8z" />
                    </svg>
                  </div>

                  {dropdownOpen && (
                    <div className="absolute top-[120%] left-0 bg-white border border-[#E6E5E5] rounded-lg z-10 w-28 max-h-48 overflow-y-auto shadow-md">
                      {balances.map((resp, index) => {
                        const flagUrl = getFlagUrl(resp);
                        const data = {
                          currency: resp.currency,
                          currencyid: resp?.meta?.country_id,
                          flag: flagUrl,
                        };
                        return (
                          <div
                            key={index}
                            className="p-2 flex gap-1 cursor-pointer hover:bg-gray-50"
                            onClick={async (e) => {
                              e.stopPropagation();
                              setDropdownOpen(false);
                              setSelectedCurrency(data);
                              setCurrency(resp.currency);
                              const newSellCurrencyId = resp?.meta?.country_id;
                              setCurrencyId(newSellCurrencyId);
                              setConvertLoading(true);
                              if (recentEdit === 'sell')
                                await getConversionData(
                                  amount,
                                  receiveCurrency,
                                  newSellCurrencyId,
                                );
                              else
                                await getInverseConversionData(
                                  amount,
                                  receiveCurrency,
                                  newSellCurrencyId,
                                );
                              balances.map((row) => {
                                if (row.currency === resp.currency) {
                                  const used = usedBalances[resp.currency] || 0;
                                  const final = row.balance - used;
                                  setBalance(final < 0 ? 0 : final);
                                }
                              });
                            }}
                          >
                            <img
                              src={flagUrl}
                              className="w-5 h-5 rounded-full"
                            />
                            <span className="text-sm">{resp.currency}</span>
                          </div>
                        );
                      })}
                    </div>
                  )}
                </div>

                {/* INPUT */}
                <input
                  value={amount}
                  type="text"
                  inputMode="decimal"
                  onKeyDown={(e) => {
                    if (
                      e.key === 'ArrowUp' ||
                      e.key === 'ArrowDown' ||
                      e.key === 'e' ||
                      e.key === '-'
                    ) {
                      e.preventDefault();
                    }
                  }}
                  className="flex-1 text-right text-[28px] font-bold border-none outline-none bg-transparent"
                  onChange={(e) => {
                    const value = e.target.value;

                    if (value === '') {
                      setAmount('');
                      setBuyAmount('');
                      amountRef.current = undefined;
                      clearTimeout(timeout.current);
                      return;
                    }

                    const num = Number(value);

                    // ✅ BLOCK zero and negatives
                    if (num <= 0) {
                      setAmount(''); // 🔥 IMPORTANT: reset UI
                      setBuyAmount('');
                      amountRef.current = undefined;
                      return;
                    }

                    const validated = value.match(/^(\d*\.{0,1}\d{0,2})$/);
                    if (!validated) return;

                    setAmount(validated[0]);
                    amountRef.current = validated[0];

                    setConvertLoading(true);
                    onChangeHandler(validated[0]);
                    setrecentEdit('sell');
                  }}
                />
              </div>

              {/* Available balance under SELL */}
              <p className="text-xs font-semibold mt-1.5">
                Available Balance :{' '}
                <b>
                  {currency
                    ? `${parseFloat(availableBalance).toFixed(2)} ${currency}`
                    : '-'}
                </b>
              </p>
            </div>

            {/* DIVIDER + SWAP */}
            <div className="flex items-center my-5">
              <div className="flex-1 h-px bg-[#E6E5E5]" />
              <div
                className="w-9 h-9 rounded-full border border-[#E6E5E5] flex items-center justify-center mx-3 cursor-pointer hover:bg-gray-50 transition-colors bg-white"
                onClick={async () => {
                  const tempCurrency = currency;
                  const tempCurrencyId = currencyid;
                  const tempSelectedCurrency = selectedCurrency;
                  const tempReceiveCurrency = receiveCurrency;
                  const tempReceiveCurrencyValue = receiveCurrencyValue;
                  const tempSelectedReceiveCurrency = selectedReceiveCurrency;
                  const tempAmount = amount;
                  const tempBuyAmount = buyAmount;

                  setCurrency(tempReceiveCurrencyValue);
                  setCurrencyId(tempReceiveCurrency);
                  setSelectedCurrency(tempSelectedReceiveCurrency);
                  setReceiveCurrency(tempCurrencyId);
                  setReceiveCurrencyValue(tempCurrency);
                  setSelectedReceiveCurrency(tempSelectedCurrency);
                  setAmount(tempBuyAmount);
                  amountRef.current = tempBuyAmount;
                  setBuyAmount(tempAmount);

                  if (tempReceiveCurrency && tempCurrencyId && tempBuyAmount) {
                    await getConversionData(
                      tempBuyAmount,
                      tempCurrencyId,
                      tempReceiveCurrency,
                    );
                  }
                }}
              >
                <svg
                  className="w-4 h-4 text-gray-600"
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="currentColor"
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                >
                  <polyline points="17 1 21 5 17 9" />
                  <path d="M3 11V9a4 4 0 0 1 4-4h14" />
                  <polyline points="7 23 3 19 7 15" />
                  <path d="M21 13v2a4 4 0 0 1-4 4H3" />
                </svg>
              </div>
              <div className="flex-1 h-px bg-[#E6E5E5]" />
            </div>

            {/* BUY */}
            <div>
              <p className="text-sm font-semibold mb-2">Buy Currency</p>

              <div className="flex items-center border border-[#E6E5E5] rounded-xl p-3">
                {/* DROPDOWN */}
                <div className="relative flex items-center gap-1.5">
                  {selectedReceiveCurrency?.flag && (
                    <img
                      src={selectedReceiveCurrency.flag}
                      className="w-[30px] h-[28px] rounded-sm"
                    />
                  )}

                  <div
                    className="flex items-center gap-1 cursor-pointer select-none"
                    onClick={(e) => {
                      e.stopPropagation();
                      setReceiveDropdownOpen(!receiveDropdownOpen);
                      setDropdownOpen(false);
                    }}
                  >
                    <span className="text-sm font-medium">
                      {selectedReceiveCurrency?.currency ||
                        receiveCurrencyValue ||
                        'Select'}
                    </span>
                    <svg
                      className="w-3 h-3 text-gray-500"
                      viewBox="0 0 12 12"
                      fill="currentColor"
                    >
                      <path d="M6 8L1 3h10L6 8z" />
                    </svg>
                  </div>

                  {receiveDropdownOpen && (
                    <div className="absolute top-[120%] left-0 bg-white border border-[#E6E5E5] rounded-lg z-10 w-28 max-h-48 overflow-y-auto shadow-md">
                      {balances.map((resp, index) => {
                        const flagUrl = getFlagUrl(resp);
                        return (
                          <div
                            key={index}
                            className="p-2 flex gap-1 cursor-pointer hover:bg-gray-50"
                            onClick={async (e) => {
                              e.stopPropagation();
                              setReceiveDropdownOpen(false);
                              setSelectedReceiveCurrency({
                                currency: resp.currency,
                                currencyid: resp?.meta?.country_id,
                                flag: flagUrl,
                              });
                              setReceiveCurrency(resp?.meta?.country_id);
                              setReceiveCurrencyValue(resp.currency);
                              setReceiveCurrencyFlag(flagUrl);
                              setConvertLoading(true);
                              if (recentEdit === 'sell')
                                await getConversionData(
                                  amount,
                                  resp?.meta?.country_id,
                                );
                              else
                                await getInverseConversionData(
                                  amount,
                                  resp?.meta?.country_id,
                                );
                              const row = balances.find(
                                (b) => b.currency === resp.currency,
                              );
                              if (row) {
                                const used = usedBalances[resp.currency] || 0;
                                const final = row.balance - used;
                                setBalance(final < 0 ? 0 : final);
                              }
                            }}
                          >
                            <img
                              src={flagUrl}
                              className="w-5 h-5 rounded-full"
                            />
                            <span className="text-sm">{resp.currency}</span>
                          </div>
                        );
                      })}
                    </div>
                  )}
                </div>

                {/* INPUT */}
                <input
                  value={buyAmount}
                  type="text"
                  inputMode="decimal"
                  className="flex-1 text-right text-[28px] font-bold border-none outline-none bg-transparent"
                  onKeyDown={(e) => {
                    if (
                      e.key === 'ArrowUp' ||
                      e.key === 'ArrowDown' ||
                      e.key === 'e' ||
                      e.key === '-'
                    ) {
                      e.preventDefault();
                    }
                  }}
                  onChange={(e) => {
                    const value = e.target.value;

                    if (value === '') {
                      setAmount('');
                      setBuyAmount('');
                      clearTimeout(timeout.current);
                      return;
                    }

                    const num = parseFloat(value);

                    // ❌ block negative & zero
                    if (isNaN(num) || num <= 0) return;

                    const validated = value.match(/^(\d*\.{0,1}\d{0,2})$/);
                    if (validated) setBuyAmount(validated[0]);

                    setConvertLoading(true);
                    onInverseChangeHandler(value);
                    setrecentEdit('buy');
                  }}
                />
              </div>

              {/* Exchange rate under BUY */}
              {exchangeRate > 0 && !convertloading && (
                <div className="mt-2.5 px-4 py-3 rounded-xl bg-[#F5F6F8] text-sm">
                  <b>Exchange Rate :</b> 1 {sellCurrency} ={' '}
                  {parseFloat(exchangeRate).toFixed(2)} {buyCurrency}
                </div>
              )}
            </div>

            {/* BUTTON */}
            {(() => {
              const isCurrencyMissing = !currency || !receiveCurrencyValue;
              const isAmountMissing = !amount || !buyAmount;
              const isDisabled =
                isCurrencyMissing || isAmountMissing || convertloading;

              return (
                <button
                  onClick={() => {
                    if (isDisabled) return;
                    navigate('/review', {
                      state: {
                        sellCurrency: sellCurrency,
                        buyCurrency: buyCurrency,
                        exchangeRate: exchangeRate,
                        convertDate: convertDate,
                        amount: amount,
                        buyAmount: buyAmount,
                        contactId: contactId,
                        from_currency: currency,
                        receiveCurrencyValue: receiveCurrencyValue,
                        receiveCurrencyId: receiveCurrency,
                        sellFlagUrl: selectedCurrency?.flag || '',
                        buyFlagUrl: selectedReceiveCurrency?.flag || '',
                        availableBalance: availableBalance,
                        convertTime: convertTime,
                      },
                    });
                  }}
                  disabled={isDisabled}
                  className={`w-full h-14 mt-5 rounded-xl border-none text-white text-xl font-bold transition-all duration-200
                    ${
                      isDisabled
                        ? 'bg-[#D7D7D7] opacity-50 cursor-not-allowed'
                        : 'bg-[#D26521] opacity-100 cursor-pointer hover:opacity-90 active:scale-[0.99]'
                    }`}
                >
                  {convertloading && (amount || buyAmount) ? (
                    <span className="flex items-center justify-center gap-2">
                      <svg
                        className="animate-spin w-5 h-5"
                        viewBox="0 0 24 24"
                        fill="none"
                      >
                        <circle
                          className="opacity-25"
                          cx="12"
                          cy="12"
                          r="10"
                          stroke="white"
                          strokeWidth="4"
                        />
                        <path
                          className="opacity-75"
                          fill="white"
                          d="M4 12a8 8 0 018-8v4a4 4 0 00-4 4H4z"
                        />
                      </svg>
                      Processing...
                    </span>
                  ) : (
                    'Review'
                  )}
                </button>
              );
            })()}
          </div>
        </div>
      )}
    </div>
  );
}

CurrencyConverterFormScreen.propTypes = {
  conversions: PropTypes.array.isRequired,
  refreshConversions: PropTypes.func.isRequired,
  convertAgainData: PropTypes.shape({
    sellAmount: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    buyAmount: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    sellCurrency: PropTypes.string,
    buyCurrency: PropTypes.string,
    sellCurrencyId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    buyCurrencyId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    sellFlag: PropTypes.string,
    buyFlag: PropTypes.string,
    trigger: PropTypes.number,
  }),
  onConvertAgainApplied: PropTypes.func,
};

export default CurrencyConverterFormScreen;
